import API from "@/api/lib/api";
import { getActiveRestaurantId } from "@/lib/idProvider";

export const getAllShift = async (restaurant_id) => {
  try {
    const resId = restaurant_id || getActiveRestaurantId();
    const response = await API.get(`restaurants/${resId}/shift-schedules`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createShift = async (data) => {
  try {
    const response = await API.post(`shift-schedules`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateShift = async (id, data) => {
  try {
    const response = await API.put(`shift-schedules/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
